module.exports = __webpack_public_path__ + "img/account-m4.d6a71ac3.png";